import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withKeys as _withKeys, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9960102c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_created_notice = _resolveComponent("created-notice")!
  const _component_detail_dialog = _resolveComponent("detail-dialog")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_app_page = _resolveComponent("app-page")!

  return (_openBlock(), _createBlock(_component_app_page, { fheader: { showCollapse: true } }, {
    fheader: _withCtx(({ collapse }) => [
      _createVNode(_component_el_form, {
        size: "default",
        "label-width": "80px",
        model: _ctx.params,
        onKeyup: _withKeys(_ctx.handleSearch, ["enter"])
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, { label: "通知编号" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                placeholder: "请输入通知编号",
                modelValue: _ctx.params.noticeCode,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.params.noticeCode) = $event)),
                maxlength: "200",
                clearable: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "通知栏" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                placeholder: "请输入通知栏",
                modelValue: _ctx.params.theme,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.params.theme) = $event)),
                maxlength: "200",
                clearable: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "状态" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                placeholder: "请选择状态",
                modelValue: _ctx.params.status,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.params.status) = $event)),
                style: {"width":"100%"},
                clearable: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.NOTICE_TYPE_LIST, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          collapse
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                label: "通知时间"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    modelValue: _ctx.params.noticeTime,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.params.noticeTime) = $event)),
                    type: "daterange",
                    format: "YYYY-MM-DD",
                    "range-separator": "至",
                    "start-placeholder": "开始时间",
                    "end-placeholder": "结束时间"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          collapse
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 1,
                label: "发布人"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    placeholder: "请输入发布人名称",
                    modelValue: _ctx.params.creatorName,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.params.creatorName) = $event)),
                    maxlength: "200",
                    clearable: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form_item, {
            "label-width": "0",
            class: "margin-left-20"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                size: "default",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleSearch())),
                onKeyup: _cache[6] || (_cache[6] = _withKeys(($event: any) => (_ctx.handleSearch()), ["enter"]))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 查询 ")
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                size: "default",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.handleReset()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 重置 ")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 2
      }, 1032, ["model", "onKeyup"])
    ]),
    header: _withCtx(() => [
      (_ctx.$has(_ctx.permissionConfig.XZTZ))
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            type: "primary",
            size: "default",
            onClick: _ctx.handleIncreased
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 新增通知 ")
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    main: _withCtx(({ height }) => [
      (_openBlock(), _createBlock(_component_el_table, {
        height: height,
        key: height,
        data: _ctx.tableData,
        border: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "noticeCode",
            label: "通知编号",
            align: "center",
            "min-width": "120"
          }, {
            default: _withCtx(({ row }) => [
              (_ctx.$has(_ctx.permissionConfig.TZXQ))
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "text",
                    class: "flex-1",
                    onClick: ($event: any) => (_ctx.handleNoticeDetail(row))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(row.noticeCode), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "updateSystem",
            label: "更新系统",
            align: "center",
            "min-width": "120"
          }, {
            default: _withCtx(({ row: { updateSystem } }) => [
              _createTextVNode(_toDisplayString(updateSystem.join()), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "noticeSystem",
            label: "同步停服系统",
            align: "center",
            "min-width": "100"
          }, {
            default: _withCtx(({ row: { noticeSystem } }) => [
              _createTextVNode(_toDisplayString(noticeSystem.join()), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "theme",
            label: "通知栏",
            "min-width": "180",
            "show-overflow-tooltip": true
          }),
          _createVNode(_component_el_table_column, {
            prop: "status",
            label: "状态",
            align: "center"
          }, {
            default: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(_ctx.$filters.getEnumLabel(_ctx.NOTICE_TYPE_LIST, row.status)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "creatorName",
            label: "发布人",
            align: "center",
            "min-width": "100"
          }),
          _createVNode(_component_el_table_column, {
            prop: "publishTime",
            label: "通知时间",
            align: "center",
            "min-width": "240"
          }, {
            default: _withCtx(({ row: { publishTime, publishEndTime } }) => [
              _createTextVNode(_toDisplayString(_ctx.$filters.formatTime(publishTime)) + "~" + _toDisplayString(_ctx.$filters.formatTime(publishEndTime)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "startUpdateTime",
            label: "开始更新时间",
            align: "center",
            "min-width": "200"
          }, {
            default: _withCtx(({ row: { startUpdateTime } }) => [
              _createTextVNode(_toDisplayString(_ctx.$filters.formatTime(startUpdateTime)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "finishUpdateTime",
            label: "更新完成时间",
            align: "center",
            "min-width": "200"
          }, {
            default: _withCtx(({ row: { finishUpdateTime } }) => [
              _createTextVNode(_toDisplayString(_ctx.$filters.formatTime(finishUpdateTime)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "操作",
            align: "center",
            "min-width": "250px",
            fixed: "right"
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("div", _hoisted_1, [
                (_ctx.$has(_ctx.permissionConfig.BJ))
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      type: "text",
                      class: "flex-1",
                      onClick: ($event: any) => (_ctx.handleNoticeEdit(row)),
                      disabled: row.status != _ctx.NOTICE_TYPE_ENUM.READY
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("编辑")
                      ]),
                      _: 2
                    }, 1032, ["onClick", "disabled"]))
                  : _createCommentVNode("", true),
                (_ctx.$has(_ctx.permissionConfig.CX))
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      type: "text",
                      class: "flex-1",
                      onClick: ($event: any) => (_ctx.handleUndo(row, _ctx.OPERATION_TYPE_ENUM.WITHDRAW)),
                      disabled: row.status != _ctx.NOTICE_TYPE_ENUM.READY
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("撤销")
                      ]),
                      _: 2
                    }, 1032, ["onClick", "disabled"]))
                  : _createCommentVNode("", true),
                (_ctx.$has(_ctx.permissionConfig.KSGX))
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 2,
                      type: "text",
                      class: "flex-1",
                      onClick: ($event: any) => (_ctx.handleStart(row, _ctx.OPERATION_TYPE_ENUM.UPDATE)),
                      disabled: row.status != _ctx.NOTICE_TYPE_ENUM.READY
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 开始更新 ")
                      ]),
                      _: 2
                    }, 1032, ["onClick", "disabled"]))
                  : _createCommentVNode("", true),
                (_ctx.$has(_ctx.permissionConfig.GXWC))
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 3,
                      type: "text",
                      class: "flex-1",
                      onClick: ($event: any) => (_ctx.handleComplete(row, _ctx.OPERATION_TYPE_ENUM.FINISHED)),
                      disabled: row.status != _ctx.NOTICE_TYPE_ENUM.UPDATING
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("更新完成 ")
                      ]),
                      _: 2
                    }, 1032, ["onClick", "disabled"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          })
        ]),
        _: 2
      }, 1032, ["height", "data"]))
    ]),
    ffooter: _withCtx(() => [
      _createVNode(_component_el_row, {
        style: {"width":"100%","padding-top":"10px"},
        type: "flex",
        justify: "end"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_pagination, {
            total: _ctx.tableTotal,
            "current-page": _ctx.params.pageNum,
            size: _ctx.params.pageSize,
            onSizeChange: _ctx.handleSizeChange,
            onCurrentChange: _ctx.handleCurrentChange
          }, null, 8, ["total", "current-page", "size", "onSizeChange", "onCurrentChange"])
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_component_created_notice, {
        visible: _ctx.createdNoticeVisible,
        "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.createdNoticeVisible) = $event)),
        "notice-item": _ctx.noticeItem,
        onHandleSearch: _ctx.handleSearch
      }, null, 8, ["visible", "notice-item", "onHandleSearch"]),
      _createVNode(_component_detail_dialog, {
        visible: _ctx.detailVisible,
        "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.detailVisible) = $event)),
        "notice-content": _ctx.noticeItem,
        onHandleSearch: _ctx.handleSearch
      }, null, 8, ["visible", "notice-content", "onHandleSearch"]),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.dialogVisible,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.dialogVisible) = $event)),
        title: "温馨提示",
        width: "30%"
      }, {
        footer: _withCtx(() => [
          _createElementVNode("span", _hoisted_3, [
            _createVNode(_component_el_button, {
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.dialogVisible = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode("取消")
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.handleOperationCallBack(_ctx.handleSearch)))
            }, {
              default: _withCtx(() => [
                _createTextVNode("确定")
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("span", {
            class: "operation-tip-text",
            innerHTML: _ctx.message
          }, null, 8, _hoisted_2)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}